import { render, staticRenderFns } from "./ListaGrupo.vue?vue&type=template&id=f2467844&scoped=true&"
import script from "./ListaGrupo.vue?vue&type=script&lang=js&"
export * from "./ListaGrupo.vue?vue&type=script&lang=js&"
import style0 from "./ListaGrupo.vue?vue&type=style&index=0&id=f2467844&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2467844",
  null
  
)

export default component.exports